// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"7226":"fe3e8de7d475bb08","7399":"8f0a7ea55e0e404b"}[chunkId] + ".css";
};